import {
  DispositionAbbreviationsArray,
  type DispositionRecord, DispositionStringFormatDefaults,
  Outcome,
  TendrilDefaultActions
} from '../types/dispositions/dispositionEnums.ts';
import  type { IntegrationDisposition, HubspotFormattedDisposition } from '@types';

function isCustomDisposition (customName: string): boolean {
  return (customName as TendrilDefaultActions !== TendrilDefaultActions.default_action
        && Object.values(TendrilDefaultActions).every(
          (tendrilDefaultName) => {
            return customName !== String(tendrilDefaultName);
          })
  );
}

export function transformHubspotMappings (
  mappings: DispositionRecord,
  callDispositions: IntegrationDisposition[],
  dispositionId: string,
): HubspotFormattedDisposition[] {
  const MAX_DISPOSITIONS = 16;
  const transformedDispositions: HubspotFormattedDisposition[] = [];
  for (let index = 0; index < MAX_DISPOSITIONS; index++) {
    const abbreviation = DispositionAbbreviationsArray[index];
    const defaultAction = DispositionStringFormatDefaults[abbreviation];
    const defaultName = TendrilDefaultActions[abbreviation];
    const mappingName = mappings[abbreviation];

    const defaultCustomDisposition: IntegrationDisposition = {
      id: index,
      attributes: {
        name: defaultName,
        outcome: Outcome.NO_ANSWER,
      },
      type: 'callDisposition',
    };

    const customDispositionMap = callDispositions.filter((map) => map.attributes.name === mappingName);

    const { id, attributes } =
        customDispositionMap[customDispositionMap.length - 1] ?? defaultCustomDisposition;

    const parsedId = String(id);

    const transformed: HubspotFormattedDisposition = {
      id: parsedId,
      dispositionId,
      abbreviation,
      defaultAction,
      customName: attributes.name,
      defaultName,
      isCustom: isCustomDisposition(attributes.name ?? mappingName),
      outcome: attributes.outcome as Outcome,
    };

    transformedDispositions.push(transformed);
  }
  
  return transformedDispositions;
}